import styled from 'styled-components';
import { CarvanaTheme, getMediaQuery } from '@carvana/showroom-theme';

const ModuleWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 524px;
  width: 100%;

  ${getMediaQuery(CarvanaTheme.breakpoint.md)}  {
    max-width: 656px;
  }
`;

export default ModuleWrapper;